<template>
  <div>
    <title-edit header="Membership benefit" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Branch :</label>
      </v-col>
      <v-col cols="6" sm="8"  xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Meeting room TH :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.meeting_room_th" @update="updateMeetingRoomTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Meeting room EN :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.meeting_room_en" @update="updateMeetingRoomEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.detail_th" @update="updateDetailTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.detail_en" @update="updateDetailEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Discount TH :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.discount_th" @update="updateDiscountTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Discount EN :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.discount_en" @update="updateDiscountEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Service TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.service_th" @update="updateServiceTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Service EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.service_en" @update="updateServiceEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Rate TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.rate_th" @update="updateRateTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Rate EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.rate_en" @update="updateRateEN" />
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteMembershipBenefit" @save-info="saveMembershipBenefit" @save-close="saveClose"></command-button>
  </div>
</template>

<script>
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import SelectOption from "../../../components/Input/selectOption";
import InputTextField from "../../../components/Input/InputTextField";
import InputEditor from "../../../components/Input/InputEditor";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import SwitchSelect from "../../../components/Input/StyleUtility";
import { mapState } from "vuex";
import {permissionMembershipBenefit, role} from "../../../util/Permission";
import Swal from 'sweetalert';
import CommandButton from "../../../components/Layout/CommandButton";

export default {
  name: "MembershipBenefitEdit",
  components: {
    CommandButton,
    SwitchSelect,
    SaveButton,
    PreviewButton,
    DeleteButton,
    InputEditor,
    InputTextField,
    SelectOption,
    LineHr,
    TitleEdit
  },
  data() {
    return {
      optionBranch: [],
      permission : null,
      save_id : null
    };
  },
  computed: {
    permissionMembershipBenefit,
    ...mapState({
      form: state => {
        return state.MembershipBenefit.form;
      }
    })
  },
  created() {
    this.permission = role;
    this.getBranchData();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    validateSave() {
      // if (!this.form.branch_id) {
      // Swal('','Please select Branch !','error');

      //   return false;
      // } else
      // if (!this.form.meeting_room_th) {
      //   Swal('','Please insert Meeting room TH !','error');
      //   return false;
      // } else if (!this.form.meeting_room_en) {
      //   Swal('','Please insert Meeting room EN !','error');
      //   return false;
      // } else
        if (!this.form.detail_th) {
        Swal('','Please insert Description TH !','error');
        return false;
      } else if (!this.form.detail_en) {
        Swal('','Please insert Description EN !','error');
        return false;
      } else if (!this.form.service_th) {
        Swal('','Please insert Service TH !','error');
        return false;
      } else if (!this.form.service_en) {
        Swal('','Please insert Service EN !','error');
        return false;
      } else if (!this.form.rate_en) {
        Swal('','Please insert Rate TH !','error');
        return false;
      } else if (!this.form.rate_th) {
          Swal('','Please insert Rate EN !','error');
          return false;
        } else {
        return true;
      }
    },
    saveClose() {
      if (this.validateSave()) {
        this.$store
                .dispatch("MembershipBenefit/saveMembershipBenefit", {
                  id: this.save_id ? this.save_id : this.form.id,
                  data: this.form
                })
                .then(res => {
                  Swal(res.response_msg);
                  if (res.response_code == 200) {
                    this.goToMembershipBenefit();
                  }
                })
                .catch(() => {
                  Swal('','Save data failed!','error');
                });
      }
    },
    saveMembershipBenefit() {
      if (this.validateSave()) {
        this.$store
          .dispatch("MembershipBenefit/saveMembershipBenefit", {
            id: this.save_id ? this.save_id : this.form.id,
            data: this.form
          })
          .then(res => {
            this.save_id = res.result.id;
            Swal(res.response_msg);
          })
          .catch(() => {
            Swal('','Save data failed!','error');
          });
      }
    },
    deleteMembershipBenefit() {
      this.$store
        .dispatch("MembershipBenefit/deleteMembershipBenefit", this.form.id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToMembershipBenefit();
          }
        })
        .catch(() => {
          Swal('','Delete data failed!','error');
        });
    },
    goToMembershipBenefit() {
      this.$router.push("/membership/membership-benefit");
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateDetailEN(val) {
      this.form.detail_en = val;
    },
    updateDetailTH(val) {
      this.form.detail_th = val;
    },
    updateRateTH(val) {
      this.form.rate_th = val;
    },
    updateRateEN(val) {
      this.form.rate_en = val;
    },
    updateDiscountEN(val) {
      this.form.discount_en = val;
    },
    updateDiscountTH(val) {
      this.form.discount_th = val;
    },
    updateServiceEN(val) {
      this.form.service_en = val;
    },
    updateServiceTH(val) {
      this.form.service_th = val;
    },
    updateMeetingRoomEN(val) {
      this.form.meeting_room_en = val;
    },
    updateMeetingRoomTH(val) {
      this.form.meeting_room_th = val;
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/switch.css";
</style>
